import { ChangeOptionRecipeRawProductsStep, ChangeRawProductOperation } from "./ChangeOptionRecipeRawProducts";
import { Spec } from "../../../services/spec/spec.types";
import { FC } from "react";
import Button from "../../../components/Button/Button";
import { UpdateSubRecipeDetailsRawProductsRequest } from "../../../services/subrecipe/subrecipe.types";
import { ButtonRow } from "./ChangeRawProducts.styles";
import { Variant } from "../../../components/Button/Button.types";
import { useUpdateSubRecipeDetailsRawProductsReview } from "../../../services/subrecipe/subrecipe.service";
import SubRecipeRawProductUpdatesTable from "./SubRecipeRawProductUpdatesTable";

interface ReviewProps {
  changeRawProductOperations: ChangeRawProductOperation[]
  selectedSpecs: Spec[],
  mutate: (body: UpdateSubRecipeDetailsRawProductsRequest) => void
  setStep: (step: ChangeOptionRecipeRawProductsStep) => void
}

const ConfirmChanges: FC<ReviewProps> = (
    {
      changeRawProductOperations,
      selectedSpecs,
      mutate,
      setStep
    }
) => {
  const updateSubRecipeDetailsRawProductsRequest: UpdateSubRecipeDetailsRawProductsRequest =
      {
        specs: selectedSpecs.map(spec => spec.specNo),
        updateOperations: changeRawProductOperations.map(changeRawProductOperations => (
            {
              oldRawProductNumber: changeRawProductOperations.currentRawProduct.moaRawProdNo,
              newRawProductNumber: changeRawProductOperations.desiredRawProduct.moaRawProdNo,
              usageAmountScale: 1
            }
        ))
      }
  const { data: updateSubRecipeDetailsRawProductsResponse } = useUpdateSubRecipeDetailsRawProductsReview(
      updateSubRecipeDetailsRawProductsRequest);
  const updates = updateSubRecipeDetailsRawProductsResponse?.data || [];

  const submit = () => {
    mutate(updateSubRecipeDetailsRawProductsRequest)
    setStep(ChangeOptionRecipeRawProductsStep.Review)
  }

  return (
      <>
        <SubRecipeRawProductUpdatesTable
            updates={updates}
        />
        <ButtonRow>
          <Button
              label={'Submit'}
              onClick={submit}
          />
          <Button
              label={'Back'}
              variant={Variant.Secondary}
              onClick={() => setStep(ChangeOptionRecipeRawProductsStep.SelectSpecs)}
          />
        </ButtonRow>
      </>
  )
}

export default ConfirmChanges;